import { NO_MODAL, SET_ACTIVE_MODAL } from "../../constants/ModalConstants";

import { GET_TOKEN } from "../../constants/ClientConstants";
import { SUCCESS } from "../../constants/BaseConstants";

const initialState: ModalStateType = {
    activeModal: NO_MODAL
};

export default (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ACTIVE_MODAL:
            return {
                ...state,
                activeModal: action.activeModal
            };
        case GET_TOKEN + SUCCESS:
            return {
                ...state,
                activeModal: action.initialState
            };
        default:
            return state;
    }
};
